export type CollateralMapLayer = "streets" | "satellite" | "hybrid" | "maptiler" | "google";

export type MapLayerSelection =
  | {
      kind: "ready";
      requested: CollateralMapLayer;
      resolved: CollateralMapLayer;
      usedFallback: boolean;
    }
  | {
      kind: "unavailable";
      requested: CollateralMapLayer;
      reason: "google-api-key";
    };

/**
 * Resolves a user layer request before any mounted Leaflet layer is removed.
 * This keeps a working base map visible when an optional provider is unavailable.
 */
export function resolveMapLayerSelection(
  requested: CollateralMapLayer,
  providers: { hasGoogleMapsKey: boolean; hasMapTilerKey: boolean },
): MapLayerSelection {
  if (requested === "google" && !providers.hasGoogleMapsKey) {
    return { kind: "unavailable", requested, reason: "google-api-key" };
  }

  if (requested === "maptiler" && !providers.hasMapTilerKey) {
    return {
      kind: "ready",
      requested,
      resolved: "satellite",
      usedFallback: true,
    };
  }

  return {
    kind: "ready",
    requested,
    resolved: requested,
    usedFallback: false,
  };
}
